const paperRecord = () => import('@/views/paperRecord/paperRecord')
const synchronizationZone = () => import('@/views/paperRecord/synchronizationZone')
const examinationZone = () => import('@/views/paperRecord/examinationZone')
const testPaperDetails = () => import('@/views/paperRecord/testPaperDetails')
const topicDetails = () => import('@/views/paperRecord/topicDetails')
const scoreSetting = () => import('@/views/paperRecord/scoreSetting')
const topicSelection = () => import('@/views/paperRecord/topicSelection')
const knowledgeName = () => import('@/views/paperRecord/knowledgeName')
const pdfView = () => import('@/views/paperRecord/pdfView')
const testAnalysis = () => import('@/views/paperRecord/testAnalysis')
const releaseEvaluation = () => import('@/views/paperRecord/releaseEvaluation')
const successfullyPublished = () => import('@/views/paperRecord/successfullyPublished')
const exportPrinting = () => import('@/views/paperRecord/exportPrinting')
const testPaperPreview = () => import('@/views/paperRecord/testPaperPreview')


export default [
    { path: '', component: paperRecord, name: 'paperRecord', meta: { title: '组卷记录' } },
    { path: '/synchronizationZone', component: synchronizationZone, name: 'synchronizationZone', meta: { title: '同步专区' } },
    { path: '/examinationZone', component: examinationZone, name: 'examinationZone', meta: { title: '中考专区' } },
    { path: '/testPaperDetails', name: 'testPaperDetails', component: testPaperDetails, meta: { title: '试卷详情' } },
    { path: '/topicDetails', component: topicDetails, name: 'topicDetails', meta: { title: '题目详情' } },
    { path: '/scoreSetting', component: scoreSetting, name: 'scoreSetting', meta: { title: '分值设置' } },
    { path: '/topicSelection', component: topicSelection, name: 'topicSelection', meta: { title: '添加选题' } },
    { path: '/knowledgeName', component: knowledgeName},
    { path: '/pdfView', component: pdfView, meta: { title: '试卷预览' } },
    { path: '/testAnalysis', component: testAnalysis, meta: { title: '试卷分析' } },
    { path: '/releaseEvaluation', component: releaseEvaluation, meta: { title: '发布测评' } },
    { path: '/successfullyPublished', component: successfullyPublished, meta: { title: '布置成功' } },
    { path: '/exportPrinting', component: exportPrinting, meta: { title: '导出打印' } },
    { path: '/testPaperPreview', component: testPaperPreview, meta: { title: '试卷预览' } },

]


// WEBPACK FOOTER //
// ./src/router/PaperRecord.js